module.exports = __webpack_public_path__ + "media/images/icon__betPick--none@3x-f187156e0c800efb455d729e5b1a8577.png";